import React from 'react';
import InputChoice from '../../../ui/InputChoice';
import { contentDataSelector } from '../../../../redux/selectors';
import { useAppSelector } from '../../../../redux/hooks';
import { validateConditions } from '../../../../conditions';
import { MustacheWithHtml } from '../../../templating/MustacheWithHtml';
export default function QuestionAndInputs({ page }) {
    const contentData = useAppSelector(contentDataSelector);
    const inputChoices = page.elements.choices.linkedItems;
    const choicesThatMeetConditions = inputChoices.filter((choice) => validateConditions(choice, contentData));
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "display-text question-text" },
            React.createElement(MustacheWithHtml, { item: page, template: page.elements.question.value })),
        choicesThatMeetConditions.map((choice) => (React.createElement(InputChoice, { key: choice.system.id, choice: choice })))));
}
//# sourceMappingURL=QuestionAndInputs.js.map